export enum BlockingTypeEnum {
    UNBLOCK = "UNBLOCK",
    BLOCKCLOSE = "BLOCK_CLOSE",
    BLOCKOPEN = "BLOCK_OPEN"
}